module.exports = __webpack_public_path__ + "img/settingsBtnUA.0dc4c1dc.png";